export default __webpack_public_path__ + "static/symbols-2225437f48992ec8321def6e1348709a.svg";